export type FilterValues = string | number;
export type SingleSelection = string | number | boolean;
export type MultipleSelection = FilterValues[];
export type RangeSelection = {
	start: FilterValues | null;
	end: FilterValues | null;
};
export type KeyValueSelection = {
	key: FilterValues | null;
	value: FilterValues | null;
};
export type MultipleKeyValueSelection = KeyValueSelection[];
export type WildcardSelection = {
	value: FilterValues;
};

export type SelectionWithLabel<T = unknown> = T & { id: FilterValues; name: string };

export type MultipleSelectionWithLabel<T = unknown> = SelectionWithLabel<T>[];

export type FilterType =
	| SingleSelection
	| MultipleSelection
	| RangeSelection
	| KeyValueSelection
	| WildcardSelection
	| SelectionWithLabel
	| MultipleSelectionWithLabel
	| MultipleKeyValueSelection;

export enum FilterTypes {
	StringSelection = 'StringSelection',
	NumberSelection = 'NumberSelection',
	SingleSelection = 'SingleSelection',
	RangeSelection = 'RangeSelection',
	KeyValueSelection = 'KeyValueSelection',
	MultipleKeyValueSelection = 'MultipleKeyValueSelection',
	SearchSelectSelection = 'SearchSelectSelection',
}

export enum FilterSelectionSteps {
	SelectFilter = 'SelectFilter',
	InputValues = 'InputValues',
}
